import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import Routing from '@pages'

import { PageUp } from '@entities/pageUp'

import { IS_PROD_ENV } from '@shared/config'
import { Btn } from '@shared/ui/btn'
import { NotchLoader } from '@shared/ui/loader'

import { withHocs } from './providers'

import './i18n'

import './index.scss'

//

const Fallback = ({ error, resetErrorBoundary }) => (
  <div
    role="alert"
    className="d-flex flex-column align-items-center justify-content-center vh-100"
  >
    <h2>Something went wrong</h2>

    {!IS_PROD_ENV && <pre>{error.message}</pre>}

    <div className="mt-3 text-center">
      <Btn onClick={resetErrorBoundary}>Try again</Btn>
      <div className="mt-3">
        We are sorry for the inconvenience. We are working on it.
        <br />
        <span className="text-muted">We will fix it as soon as possible.</span>
      </div>
    </div>
    <div
      style={{
        position: 'absolute',
        bottom: '2rem',
      }}
    >
      <img src="todo" alt="Logo" style={{ height: 48 }} />
    </div>
  </div>
)

//

const App = ({ onLogout }) => {
  return (
    <ErrorBoundary FallbackComponent={Fallback}>
      <Suspense fallback={<NotchLoader />}>
        <Routing onLogout={onLogout} />
        <PageUp />
      </Suspense>
    </ErrorBoundary>
  )
}

export default withHocs(App)
